__turbopack_context__.v({
  "container": "lEgpUq_container",
  "item": "lEgpUq_item",
  "items": "lEgpUq_items",
  "items__grid": "lEgpUq_items__grid",
  "items__grid--2": "lEgpUq_items__grid--2",
  "items__grid--3": "lEgpUq_items__grid--3",
  "items__row-circle": "lEgpUq_items__row-circle",
  "items__row-landscape": "lEgpUq_items__row-landscape",
  "items__row-portrait": "lEgpUq_items__row-portrait",
  "placeholder": "lEgpUq_placeholder",
  "placeholder__circle": "lEgpUq_placeholder__circle",
  "placeholder__label": "lEgpUq_placeholder__label",
  "placeholder__landscape": "lEgpUq_placeholder__landscape",
  "placeholder__portrait": "lEgpUq_placeholder__portrait",
  "shimmer": "lEgpUq_shimmer",
  "text-bar-sweep": "lEgpUq_text-bar-sweep",
  "title": "lEgpUq_title",
});
